import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import LocationService from '../../../locationservice';
import UISettings from '../../../utils/UISettings.js';
import {
  setLocationServiceLoading,
  setPending,
  setCurrentFoundLocation,
  setPreviouslyUsedLocations,
  setErrorMessage,
  setGeolocationEnabled
} from '../../../appState/ducks/listingPageLocationSearch';
import { removeAllPlaceSpecificAvailabilities } from '../../../appState/ducks/listingPageProducts';
import { setLocation, searchCurrentLocationDescriptor } from './locationSearchHelpers';
import LocationBlock from './components/LocationSearch/LocationBlock';
import translations from './translations';

const PAGE_INFO_FOR_ANALYTICS = 'Listing page'; // DON'T CHANGE THE VALUE, the format of value is due to analytics purposes
const TOP_LOCATION_BLOCK_NAME = 'above product listing'; // DON'T CHANGE THE VALUE, the format of value is due to analytics purposes
let previousLocationServiceState = '';

export default function initLocationSearch() {
  // get element where to place the location search on the top of the listing page
  const topLocationSearchElement = document.querySelector(
    'div[data-anonid="location-search-block"] > article[data-component="locationsearch"]'
  );

  if (!topLocationSearchElement) {
    return;
  }

  UISettings.watchChanges('groupcallIsLoading', UISettings.Type.USER, initLocationService);
  initLocationService(UISettings.get('groupcallIsLoading', UISettings.Type.USER));
  LocationService.addEventListener('locationstatechange', onlocationstatechange, false);

  // when Ajax response for listing page paging/filtering comes from server
  window.addEventListener('loadAjaxProductsAvailabilities', searchCurrentLocationDescriptor);

  // show the element
  topLocationSearchElement.removeAttribute('hidden');

  // turn on geolocation if not turned off on server
  if (topLocationSearchElement.getAttribute('data-geolocation') === 'true') {
    const dispatch = window.appState.dispatch;
    dispatch(setGeolocationEnabled(true));
  }

  ReactDOM.render(
    <Provider store={window.appState}>
      <LocationBlock name={TOP_LOCATION_BLOCK_NAME} />
    </Provider>,
    topLocationSearchElement
  );
}

function initLocationService(groupcallIsLoading) {
  if (groupcallIsLoading) {
    return;
  }
  LocationService.load();
}

function onlocationstatechange(event) {
  const state = event.detail.status;
  const dispatch = window.appState.dispatch;

  switch (state) {
    case LocationService.LocationState.LOADED: {

      console.log('INIT_LOCATION_SEARCH - LocationService.LocationState.LOADED');

      dispatch(setPreviouslyUsedLocations(LocationService.getPreviousLocations()));
      dispatch(setLocationServiceLoading(false));

      // autostock checker
      if (window.App.settings.get('component.mcd.stockchecker.auto') &&
        window.appState.getState().listingPage.locationSearch.previouslyUsedLocations.length > 0) {

        setLocation(
          true,
          window.appState.getState().listingPage.locationSearch.previouslyUsedLocations[0],
          PAGE_INFO_FOR_ANALYTICS,
          TOP_LOCATION_BLOCK_NAME
        );
      }

      previousLocationServiceState = state;
      break;
    }

    case LocationService.LocationState.RESOLVING: {
      console.log('INIT_LOCATION_SEARCH - LocationService.LocationState.RESOLVING');


      previousLocationServiceState = state;
      break;
    }
    case LocationService.LocationState.READY: {
      console.log('INIT_LOCATION_SEARCH - LocationService.LocationState.READY');

      if (event.detail.statusText === 'clearlocation') {
        dispatch(setCurrentFoundLocation(null));
        dispatch(setErrorMessage(''));

        if (isListingRenderedInReact()) {
          dispatch(removeAllPlaceSpecificAvailabilities());
        }
      }

      previousLocationServiceState = state;
      break;
    }
    case LocationService.LocationState.PENDING: {

      console.log('INIT_LOCATION_SEARCH - LocationService.LocationState.PENDING');

      // LocationService.LocationState.PENDING can be called many times
      if (previousLocationServiceState !== LocationService.LocationState.PENDING) {
        dispatch(setPending(true));
      }
      previousLocationServiceState = state;
      break;
    }
    case LocationService.LocationState.COMPLETE: {

      console.log('INIT_LOCATION_SEARCH - LocationService.LocationState.COMPLETE');
      const locationDescriptor = LocationService.getLocation();
      dispatch(setPending(false));
      dispatch(setCurrentFoundLocation({
        location: locationDescriptor.location,
        postcode: locationDescriptor.postcode
      }));
      dispatch(setPreviouslyUsedLocations(LocationService.getPreviousLocations()));


      previousLocationServiceState = state;
      break;
    }
    case LocationService.LocationState.TIMEOUT:
    case LocationService.LocationState.ERROR:
    case LocationService.LocationState.FAILED: {

      console.log(`INIT_LOCATION_SEARCH - LocationService.LocationState.${state}`);

      if (previousLocationServiceState !== LocationService.LocationState.ERROR ||
        previousLocationServiceState !== LocationService.LocationState.TIMEOUT ||
        previousLocationServiceState !== LocationService.LocationState.FAILED
      ) {
        dispatch(setPending(false));
        let errorMessage = translations.postcodeCheckerSearchingError;

        if (event && event.detail && typeof event.detail.statusText === 'string') {
          errorMessage = event.detail.statusText;
        }
        dispatch(setErrorMessage(errorMessage));
      }

      previousLocationServiceState = state;
      break;
    }
    default: {
      break;
    }

  }

  function isListingRenderedInReact() {
    return window.appState.getState().listingPage.pageSetup.renderReactProductList;
  }
}
